import app from 'flarum/forum/app';
import { confirmAsync } from '../../common/components/confirmAsync';
import Page from 'flarum/common/components/Page';
import extractText from 'flarum/common/utils/extractText';
import { MpNavHelper } from './MpNavHelper';
import MpSkeleton from './MpSkeleton';
import { cartStore } from '../../common/utils/cartStore';
import { formatMoney } from '../../common/utils/currency';
import { productUrl } from '../../common/utils/productUrl';
import { mpImage } from '../../common/utils/mpImage';
export default class CartPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'MarketplacePage App--index MpCart-body';
    app.setTitle(extractText(app.translator.trans('ramon-marketplace.forum.cart.title')));
    this.unsub = cartStore.subscribe(() => m.redraw());
    cartStore.ensureFresh();
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.unsub?.();
  }
  t(k, vars) {
    return app.translator.trans('ramon-marketplace.forum.' + k, vars);
  }
  async confirmClear() {
    const ok = await confirmAsync({
      title: this.t('cart.confirm_clear_title') || 'Esvaziar carrinho',
      message: this.t('cart.confirm_clear'),
      confirmLabel: this.t('cart.confirm_clear_action') || 'Esvaziar',
      danger: true
    });
    if (!ok) return;
    try {
      await cartStore.clear();
      app.alerts.show({
        type: 'success'
      }, this.t('cart.cleared'));
    } catch {
      app.alerts.show({
        type: 'error'
      }, this.t('cart.clear_error'));
    }
  }

  /**
   * Wrap genérico para handlers de quantidade/remoção. cartStore.update/remove
   * podem rejeitar (rede, 409, conflito de estado). Sem catch aqui o erro
   * vira `unhandledrejection` e a UI fica dessincronizada com o servidor.
   */
  async handleCartOp(op) {
    try {
      await op();
    } catch (e) {
      const code = e?.response?.error || 'cart_op_error';
      app.alerts.show({
        type: 'error'
      }, this.t('cart.update_error_' + code, {
        fallback: this.t('cart.clear_error')
      }));
      // cartStore já restaurou o estado em caso de falha — só precisa redraw
      m.redraw();
    }
  }
  colorFor(name) {
    const palette = ['#3f88f6', '#8b5cf6', '#e7672e', '#22c55e', '#f59e0b', '#ef4444', '#06b6d4', '#ec4899'];
    let h = 0;
    for (let i = 0; i < name.length; i++) h = h * 31 + name.charCodeAt(i) >>> 0;
    return palette[h % palette.length];
  }
  view() {
    const state = cartStore.get();
    const itemCount = state.items.reduce((s, it) => s + it.quantity, 0);
    return m("div", {
      className: "MpCart"
    }, MpNavHelper(), m("header", {
      className: "MpCart-header"
    }, m("div", {
      className: "MpCart-headerTitle"
    }, m("h1", null, this.t('cart.title')), m("span", {
      className: "MpCart-count"
    }, state.items.length === 0 ? this.t('cart.empty_hint') : this.t('cart.items_count', {
      count: itemCount
    })))), m("section", {
      className: "MpCart-section"
    }, state.items.length > 0 && m("div", {
      className: "MpCart-toolbar"
    }, m("a", {
      href: app.route('marketplace.shop'),
      config: m.route.link,
      className: "MpCart-continueLink"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), " ", this.t('cart.continue') || 'Continuar comprando'), m("button", {
      type: "button",
      className: "MpBtn MpBtn--ghost MpCart-clearBtn",
      onclick: () => this.confirmClear()
    }, m("i", {
      className: "fas fa-trash-alt"
    }), " ", this.t('cart.clear'))), state.loading ? m(MpSkeleton, {
      variant: "cart"
    }) : state.items.length === 0 ? m("div", {
      className: "MpCart-empty"
    }, m("i", {
      className: "fas fa-shopping-cart"
    }), m("p", null, this.t('cart.empty')), m("a", {
      href: app.route('marketplace.shop'),
      config: m.route.link,
      className: "MpBtn MpBtn--primary"
    }, m("i", {
      className: "fas fa-store"
    }), " ", this.t('cart.go_shop'))) : m("div", {
      className: "MpCart-grid"
    }, m("main", {
      className: "MpCart-main"
    }, m("div", {
      className: "MpCart-items"
    }, state.items.map(it => this.renderItem(it)))), m("aside", {
      className: "MpCart-side"
    }, m("div", {
      className: "MpCart-summary"
    }, m("h3", null, this.t('checkout.summary')), m("div", {
      className: "MpCart-summary-row"
    }, m("span", null, this.t('cart.subtotal')), m("strong", null, formatMoney(state.totals.subtotal))), state.totals.shipping > 0 && m("div", {
      className: "MpCart-summary-row"
    }, m("span", null, this.t('cart.shipping')), m("strong", null, formatMoney(state.totals.shipping))), m("div", {
      className: "MpCart-summary-row MpCart-summary-row--total"
    }, m("span", null, this.t('cart.total')), m("strong", null, formatMoney(state.totals.total))), m("a", {
      href: app.route('marketplace.checkout'),
      config: m.route.link,
      className: "MpBtn MpBtn--primary MpCart-checkoutBtn"
    }, m("i", {
      className: "fas fa-lock"
    }), " ", this.t('cart.checkout')))))));
  }
  renderItem(it) {
    // Bundle item: linha única representando o pacote inteiro.
    if (it.bundle) {
      const b = it.bundle;
      const color = this.colorFor(b.name || 'x');
      return m("div", {
        className: "MpCart-item MpCart-item--bundle",
        key: it.id
      }, m("div", {
        className: "MpCart-item-icon",
        style: {
          '--mp-icon-bg': color + '1f',
          '--mp-icon-fg': color
        }
      }, b.image ? m("img", Object.assign({}, mpImage(b.image), {
        alt: "",
        loading: "lazy"
      })) : m("i", {
        className: "fas fa-boxes"
      })), m("div", {
        className: "MpCart-item-body"
      }, m("div", {
        className: "MpCart-item-name"
      }, m("i", {
        className: "fas fa-boxes"
      }), " ", b.name), m("div", {
        className: "MpCart-item-chips"
      }, m("span", {
        className: "MpChip MpChip--ot"
      }, m("i", {
        className: "fas fa-boxes"
      }), " ", this.t('cart.bundle') || 'Pacote'), b.products.slice(0, 3).map(p => m("span", {
        key: p.id,
        className: "MpChip"
      }, m("i", {
        className: p.package_name ? 'fab fa-php' : 'fas fa-cube'
      }), " ", p.name)), b.products.length > 3 && m("span", {
        className: "MpChip"
      }, "+", b.products.length - 3))), m("div", {
        className: "MpCart-item-qty"
      }, m("span", {
        style: "padding: 0 14px; font-weight: 800;"
      }, "\xD7", it.quantity)), m("div", {
        className: "MpCart-item-total"
      }, m("strong", null, formatMoney(b.price * it.quantity))), m("button", {
        type: "button",
        className: "MpCart-item-remove",
        title: this.t('cart.remove'),
        onclick: () => this.handleCartOp(() => cartStore.remove(it.id))
      }, m("i", {
        className: "fas fa-trash"
      })));
    }
    const p = it.product;
    if (!p) return null;
    // Cap por tipo: físico = stock, pool = assets disponíveis, demais = 999
    const max = p.type === 'physical' ? p.stock ?? 1 : p.unique_per_buyer ? Math.max(1, Number(p.pool_available ?? 0)) : 999;
    const color = this.colorFor(p.name || 'x');
    const isService = p.type === 'service';
    const isComposer = !!p.package_name;
    const isRecurring = p.billing_cycle === 'monthly' || p.billing_cycle === 'yearly';
    // Em produtos com dual-billing o cliente escolhe o ciclo no momento do
    // add-to-cart, salvo em CartItem.selected_cycle. Aqui usamos esse valor
    // como "ciclo efetivo" — sem ele, cai no billing_cycle padrão do produto.
    const effectiveCycle = it.selected_cycle || p.billing_cycle;
    return m("div", {
      className: "MpCart-item",
      key: it.id
    }, m("a", {
      href: productUrl(p),
      config: m.route.link,
      className: "MpCart-item-icon",
      style: {
        '--mp-icon-bg': color + '1f',
        '--mp-icon-fg': color
      }
    }, p.image ? m("img", Object.assign({}, mpImage(p.image), {
      alt: "",
      loading: "lazy"
    })) : m("i", {
      className: isService ? 'fas fa-concierge-bell' : isComposer ? 'fab fa-php' : p.type === 'digital' ? 'fas fa-cloud-download-alt' : 'fas fa-box'
    })), m("div", {
      className: "MpCart-item-body"
    }, m("a", {
      href: productUrl(p),
      config: m.route.link,
      className: "MpCart-item-name"
    }, p.name), m("div", {
      className: "MpCart-item-chips"
    }, isComposer && m("span", {
      className: "MpChip MpChip--ot"
    }, m("i", {
      className: "fab fa-php"
    }), " Composer"), isService && m("span", {
      className: "MpChip MpChip--ot"
    }, m("i", {
      className: "fas fa-concierge-bell"
    }), " ", this.t('shop.service') || 'Serviço'), effectiveCycle === 'monthly' && m("span", {
      className: "MpChip MpChip--sub"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), " ", this.t('checkout.cycle_monthly') || 'Mensal'), effectiveCycle === 'yearly' && m("span", {
      className: "MpChip MpChip--sub"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), " ", this.t('checkout.cycle_yearly') || 'Anual'), p.is_open_source && m("span", {
      className: "MpChip"
    }, m("i", {
      className: "fas fa-code"
    }), " ", this.t('shop.open_source') || 'Open source')), !p.is_open_source && m("div", {
      className: "MpCart-item-unitPrice"
    }, formatMoney(p.price), " ", this.t('cart.each') || 'cada')), m("div", {
      className: "MpCart-item-qty"
    }, m("button", {
      type: "button",
      disabled: it.quantity <= 1,
      onclick: () => this.handleCartOp(() => cartStore.update(it.id, Math.max(1, it.quantity - 1)))
    }, m("i", {
      className: "fas fa-minus"
    })), m("input", {
      type: "number",
      min: "1",
      max: max,
      value: it.quantity,
      onchange: e => {
        const q = Math.max(1, Math.min(max, Number(e.target.value) || 1));
        this.handleCartOp(() => cartStore.update(it.id, q));
      }
    }), m("button", {
      type: "button",
      disabled: it.quantity >= max,
      onclick: () => this.handleCartOp(() => cartStore.update(it.id, Math.min(max, it.quantity + 1)))
    }, m("i", {
      className: "fas fa-plus"
    }))), m("div", {
      className: "MpCart-item-total"
    }, p.is_open_source ? m("span", {
      className: "MpCart-item-total-free"
    }, this.t('shop.free') || 'Grátis') : m('[', null, m("strong", null, formatMoney(p.price * it.quantity)), isRecurring && m("small", null, "/", effectiveCycle === 'yearly' ? this.t('shop.per_year_short') : this.t('shop.per_month_short')))), m("button", {
      type: "button",
      className: "MpCart-item-remove",
      title: this.t('cart.remove'),
      onclick: () => this.handleCartOp(() => cartStore.remove(it.id))
    }, m("i", {
      className: "fas fa-trash"
    })));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/CartPage', CartPage);